import {
	CouponApplicationRequest,
	CouponValidationRequest,
	ValidCouponApplicationRequest,
	ValidCouponValidationRequest,
} from '../interfaces/checkout-coupon-validation.interface';

export function canApplyCoupon<T extends CouponApplicationRequest>(
	request: T
): request is T & ValidCouponApplicationRequest {
	return !!request.appliedCoupon && !!request.localChannelId;
}

export function canValidateCoupon<T extends CouponValidationRequest>(
	request: T
): request is T & ValidCouponValidationRequest {
	return request.coupon !== null && !!request.localChannelId && request.cartList.length > 0;
}

export function getCouponValidationFailureMessage(error: Error): string {
	return error?.['message'] ?? 'Unable to validate coupon.';
}
